/*
 * @Description: 图片上传
 */
export default {
    label: '图片上传',
    type: 'upload',
    property: '',
    value: ''
}
